import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import Circle_Write3 from "../../components/ExcerciseTypes/Circle_Write3";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P10-E1",
    // audio: "Audios/p26_e2.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page26/Key/E2answerKey.png",
    component: MatchDots,
    stylesTextInput: { borderBottom: "dotted" },
    fontSize: 30,
    inputSize: 35,
    titleQuestion: [
      {
        title: `
        <div><img src="img/FriendsPlus/Page25/Demo/1.jpg" style="height:30mm;margin-left:-70px;margin-top:-30px "/> </div>
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Nháy chuột vào chấm đỏ bất kì để vẽ điểm đầu.<br>
        Nháy chuột vào chấm đỏ khác để vẽ điểm cuối.<br>
        Ta được một đường thẳng. <br>
        Tiếp tục như vậy để vẽ góc tù.
        </span>
        <video src="Audios/guide/p32_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questionImage: [],
    hideBtnFooter: true,
    question: {
      DrawLines: {
        multipleLine: 2,
        boxMatch: [
          //Hàng 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "27px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "92px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "159px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "224px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "290px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "356px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "423px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 7
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "488px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 8
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "554px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 9
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 10
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "620px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7

          //Hàng 11
          {
            boxMatchStyle: {
              position: "absolute",
              top: "27px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 1
          {
            boxMatchStyle: {
              position: "absolute",
              top: "86px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 2
          {
            boxMatchStyle: {
              position: "absolute",
              top: "148px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 3
          {
            boxMatchStyle: {
              position: "absolute",
              top: "209px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, // 4
          {
            boxMatchStyle: {
              position: "absolute",
              top: "271px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //5
          {
            boxMatchStyle: {
              position: "absolute",
              top: "332px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //6
          {
            boxMatchStyle: {
              position: "absolute",
              top: "392px",
              left: "686px",
              width: "13px",
              height: "13px",
              borderRadius: "50%",
              border: "none",
              background: "none",
              backgroundColor: "rgb(219,122,121)",
            },
          }, //7
        ],
        answers: ["0-6", "1-7", "4-6", "3-8", "5-7", "2-9"],
        initialValue: [],
      },
      Layout: `
      <div style='display:flex; align-items: center; max-width: 1000px; font-size:25px;'>
      	<div style='font-size:35px; color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
      	  <b>1</b>
      	</div>
        Vẽ góc tù (theo mẫu).
      </div> <br>
      <img src='img/FriendsPlus/Page32/E1/1.jpg' style='width: 13cm; height: 6cm'  />
      <div style='position: relative'>
        <img src='img/FriendsPlus/Page32/E1/2.jpg' style='width: 19cm; height: 11cm'  />

        <div style='display:flexmargin-top:40px;margin-bottom:50px'>
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />
          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />

          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
          <input id='9' type= 'boxMatch' />
          <input id='10' type= 'boxMatch' />
          <input id='11' type= 'boxMatch' />
          <input id='12' type= 'boxMatch' />
          <input id='13' type= 'boxMatch' />

          <input id='14' type= 'boxMatch' />
          <input id='15' type= 'boxMatch' />
          <input id='16' type= 'boxMatch' />
          <input id='17' type= 'boxMatch' />
          <input id='18' type= 'boxMatch' />
          <input id='19' type= 'boxMatch' />
          <input id='20' type= 'boxMatch' />

          <input id='21' type= 'boxMatch' />
          <input id='22' type= 'boxMatch' />
          <input id='23' type= 'boxMatch' />
          <input id='24' type= 'boxMatch' />
          <input id='25' type= 'boxMatch' />
          <input id='26' type= 'boxMatch' />
          <input id='27' type= 'boxMatch' />

          <input id='28' type= 'boxMatch' />
          <input id='29' type= 'boxMatch' />
          <input id='30' type= 'boxMatch' />
          <input id='31' type= 'boxMatch' />
          <input id='32' type= 'boxMatch' />
          <input id='33' type= 'boxMatch' />
          <input id='34' type= 'boxMatch' />

          <input id='35' type= 'boxMatch' />
          <input id='36' type= 'boxMatch' />
          <input id='37' type= 'boxMatch' />
          <input id='38' type= 'boxMatch' />
          <input id='39' type= 'boxMatch' />
          <input id='40' type= 'boxMatch' />
          <input id='41' type= 'boxMatch' />

          <input id='42' type= 'boxMatch' />
          <input id='43' type= 'boxMatch' />
          <input id='44' type= 'boxMatch' />
          <input id='45' type= 'boxMatch' />
          <input id='46' type= 'boxMatch' />
          <input id='47' type= 'boxMatch' />
          <input id='48' type= 'boxMatch' />

          <input id='49' type= 'boxMatch' />
          <input id='50' type= 'boxMatch' />
          <input id='51' type= 'boxMatch' />
          <input id='52' type= 'boxMatch' />
          <input id='53' type= 'boxMatch' />
          <input id='54' type= 'boxMatch' />
          <input id='55' type= 'boxMatch' />

          <input id='56' type= 'boxMatch' />
          <input id='57' type= 'boxMatch' />
          <input id='58' type= 'boxMatch' />
          <input id='59' type= 'boxMatch' />
          <input id='60' type= 'boxMatch' />
          <input id='61' type= 'boxMatch' />
          <input id='62' type= 'boxMatch' />

          <input id='63' type= 'boxMatch' />
          <input id='64' type= 'boxMatch' />
          <input id='65' type= 'boxMatch' />
          <input id='66' type= 'boxMatch' />
          <input id='67' type= 'boxMatch' />
          <input id='68' type= 'boxMatch' />
          <input id='69' type= 'boxMatch' />

          <input id='70' type= 'boxMatch' />
          <input id='71' type= 'boxMatch' />
          <input id='72' type= 'boxMatch' />
          <input id='73' type= 'boxMatch' />
          <input id='74' type= 'boxMatch' />
          <input id='75' type= 'boxMatch' />
          <input id='76' type= 'boxMatch' />

          <input id='77' type= 'boxMatch' />
          <input id='78' type= 'boxMatch' />
          <input id='79' type= 'boxMatch' />
          <input id='80' type= 'boxMatch' />
          <input id='81' type= 'boxMatch' />
          <input id='82' type= 'boxMatch' />
          <input id='83' type= 'boxMatch' />

          <input id='84' type= 'boxMatch' />
          <input id='85' type= 'boxMatch' />
          <input id='86' type= 'boxMatch' />
          <input id='87' type= 'boxMatch' />
          <input id='88' type= 'boxMatch' />
          <input id='89' type= 'boxMatch' />
          <input id='90' type= 'boxMatch' />

          <input id='91' type= 'boxMatch' />
          <input id='92' type= 'boxMatch' />
          <input id='93' type= 'boxMatch' />
          <input id='94' type= 'boxMatch' />
          <input id='95' type= 'boxMatch' />
          <input id='96' type= 'boxMatch' />
          <input id='97' type= 'boxMatch' />
          
        </div>
  
        </div>
        </div>
        
      `,
    },
  },
  2: {
    unit: "Review 2",
    id: "4WB-R2-P49-E5",
    audio: "",
    video: "",
    colorWhite:true,
    exerciseKey: "img/FriendsPlus/Page32/Key/E2answerKey.png",
    component: Circle_Write,
    // checkUppercase: true,
    isHiddenCheck: true,
    

    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào hình thích hợp để chọn đáp án.</span>
        <video src="Audios/guide/p32_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    titleQuestion: [
      {
        num: "",
        title: `
      		  `,
        color: "rgb(99,197,244)",
      },
    ],
    question: {
      Write: {
        isHiddenCheck: true,
        maxLength: 10,
        inputStyle: {
          width: 250,
          fontSize: 24,
          textAlign: "center",
          height: 29,
          paddingBottom: 10,
          textTransform: "uppercase",
        },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          padding: 69,
          borderRadius: "50%",
          border: "3px solid white",
          fontSize: 25,
          marginRight: 23,
          borderColor: "transparent",
          fontWeight: "bold",
          color: "transparent",
        },
        selectWordStyle: {
          border: "3px solid white",
          padding: "93px 70px",
          borderColor: "#00aeef",
          color: "transparent",
        },
        limitSelect: 1,
        listWords: [
          `I1111 &ensp;&ensp;&ensp;&ensp;&ensp; they1 &ensp;&ensp;&ensp;&ensp;&ensp; they1`, //0
        ],
        answers: ["0-8"],
        initialValue: [],
      },
      Layout: `
      <div style='display:flex; align-items: center; max-width: 1000px'>
      	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
      	  <b>2</b>
      	</div>
        Trong các hình ảnh dưới đây. Em thấy hình nào có góc có số đo bằng 90<sup>o</sup>?
      </div> <br>
      <div style='position: relative; max-width: 1500px;  margin-bottom: 350px'>

      <img src='img/FriendsPlus/Page32/E2/1.jpg' style='width: 25cm; height: 8cm'>
        
        <div style=" position: absolute; top: 131px; left: 23px; width: max-content"><input id='0' type='Circle'/></div>

        
	    </div>
      `,
    },
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page32/Key/E3answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
   
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Di chuyển thước đo góc để đo rồi viết số đó góc vào chỗ chấm.</span>
        <video src="Audios/guide/p32_e3.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "0px",
        inputTop: "374px",
        ResultProtractor:[
          {
            textResult: 120,
            styleResult:{
              top: -57,
              left:677
            }
          },
          {
            textResult: 120,
            styleResult:{
              top:-380,
              left:883
            },
          },
          {
            textResult: 90,
            styleResult:{
              top:-380,
              left:883
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:-165,
              left:1105
            },
          },
          {
            textResult: 90,
            styleResult:{
              top:-165,
              left:1105
            }
          },
          {
            textResult: 90,
            styleResult:{
              top:56 ,
              left:880
            },
          },
        ],
        result: [
          //a
          {
            id: 0,
            top: 19, // top cây thước sau khi đặt vô hình
            left: 702, // left cây thước sau khi đặt vô hình
            rotate: -90,
          },
          {
            id: 1,
            top: 19, // top cây thước sau khi đặt vô hình
            left: 702, // left cây thước sau khi đặt vô hình
            rotate: -29,
          },
          //b
          {
            id: 2,
            top: 24, // top cây thước sau khi đặt vô hình
            left: 702, // left cây thước sau khi đặt vô hình
            rotate: 0,
          },
          {
            id: 3,
            top: 24, // top cây thước sau khi đặt vô hình
            left: 702, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          //c
          {
            id: 4,
            top: 24, // top cây thước sau khi đặt vô hình
            left: 703, // left cây thước sau khi đặt vô hình
            rotate: 90,
          },
          {
            id: 5,
            top: 24, // top cây thước sau khi đặt vô hình
            left: 703, // left cây thước sau khi đặt vô hình
            rotate: 180,
          },
        ],
      },
    ],
    // hideBtnFooter: true,
    maxLength: 3,
    stylesTextInput: {
      fontSize: 23,
      borderBottom: "2px dotted",
      textAlign: "end",
    },
    inputSize: 60,
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    // recorder: true,

    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        
        <div style='display:flex;margin-top:-20px'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-bottom :20px;margin-top:-10px'>
        	  <b>3</b>
        	</div>
          Dùng thước đo góc để đo các góc đỉnh G:
        </div>
        
      <div style="position: relative; margin-right: 100px; width: 1000px">
        <img src="/img/FriendsPlus/Page32/E3/1.jpg"  style="height:10cm;margin-top:50px;position:absolute;top:-60px;left:550px" >
        
       
        
        <div
          style="
            position: absolute;
            left: 896px;
            top: 186px;
            background-color: red;
            width: 12px;
            height: 12px;
            border-radius: 50%;
          "
          ></div>
      </div>
      <div
          id="protractor"
          style="position: absolute;top: 307px;left: 200px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>

      <div style='width: 1000px; height: 800px'>
      <table style="position: relative; border-collapse: collapse; margin: 20px auto; left: -200px">
        <tr>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Góc</th>
          <th style="border: 1px solid black; padding: 8px; text-align: left;">Số đo góc</th>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">a) Góc đỉnh G, cạnh GA, GN</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='4'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">b) Góc đỉnh G, cạnh GA, GE</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='5'><sup>o</sup></td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 8px; text-align: left;">c) Góc đỉnh G, cạnh GE,GM</td>
          <td style="border: 1px solid black; padding: 8px; text-align: left;"><input id='6'><sup>o</sup></td>
        </tr>
      </table>
      </div>
        `,
        answer: ["120", "90", "90"],
      },
    ],
  },
  4: {
    unit: "Unit 2",
    id: "FP8-WB-demo-2023-U1-P19-E1",
    audio: "",
    video: "",
    // protractor: true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page32/Key/E4answerKey.png",
    component: T6,
    inputSize: 70,
    maxLength: 4,
    stylesTextInput: {
      background: "transparent",
      border: "none",
      borderBottom: "2px dotted gray",
      fontSize: "24px",
      textAlign: "center",
    },
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>
        Đếm số góc rồi điền số thích hợp vào chỗ chấm.
        </span>
        <video src="Audios/guide/p32_e4.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    isHiddenCheck:true,
    titleQuestion: [
      {
        title: `
				`,
        color: "rgb(28, 192, 217)",
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='display:flex; align-items: center;'>
        	<div style='font-size:35px;color:white;background:rgb(89 188 141);border-radius:50%;text-align:center; width:50px;height:50px;margin-right:10px;margin-top:-10px'>
        	  <b>4</b>
        	</div>
          <span style='padding: 0px 10px 0px 10px; background-color: rgb(255,214,0); border-radius: 10px; '> Đ, S </span> &ensp;?
        </div> <br>
        <img src='img/FriendsPlus/Page32/E4/1.jpg' style='width: 11cm; height: 9cm; margin-bottom: 50px; margin-left: 100px'  /><br>
				<div>
        a) Trong hình bên có góc nhọn, góc tù, góc vuông. <span style='padding: 5px 10px 5px 10px; border: 2px solid rgb(255,214,0); border-radius: 10px;'><input id='0'></span> <br> <br>
        b) Trong hình bên có góc bẹt. <span style='padding: 5px 10px 5px 10px; border: 2px solid rgb(255,214,0); border-radius: 10px;'><input id='1'></span>
        </div>
				
				</div>
				
        `,
        answer: ["36", "44"],
      },
    ],
  },
};

export default json;
